/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleMeetRegular from './google-meet-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleMeetRegular {...validProps} />;
}
SvgComponent.iconName = 'googleMeetRegular';

export const GoogleMeetRegularIcon = svgIconWrapper(SvgComponent);
